import type {
  TransactionDetailsDialogDirection,
  TransactionDetailsDialogSelection,
  TransactionDetailsDialogSource,
} from './transaction-details.types';

const getDirection = (direction: unknown): TransactionDetailsDialogDirection | null => {
  return direction === 'in' || direction === 'out' ? direction : null;
};

const getTransactionSource = (
  transactionSource: unknown,
  direction: TransactionDetailsDialogDirection | null,
): TransactionDetailsDialogSource | null => {
  if (
    transactionSource === 'INCOMING_TRANSFER' ||
    transactionSource === 'OUTGOING_TRANSFER' ||
    transactionSource === 'GENERIC_TRANSFER'
  ) {
    return transactionSource;
  }

  if (direction === 'in') return 'INCOMING_TRANSFER';
  if (direction === 'out') return 'OUTGOING_TRANSFER';

  return null;
};

export const mapRowToDialogSelection = (row: {
  transactionId?: unknown;
  direction?: unknown;
  transactionSource?: unknown;
}): TransactionDetailsDialogSelection => {
  const isNonEmptyString =
    typeof row.transactionId === 'string' && row.transactionId.trim().length > 0;
  const direction = getDirection(row.direction);

  return {
    transactionId: isNonEmptyString ? (row.transactionId as string) : null,
    direction,
    transactionSource: getTransactionSource(row.transactionSource, direction),
  };
};
